import {
    MAP__16,
    CITY__16,
    LOCATION__16,
    PLANE__16,
    TRAIN__16
} from '@homeaway/svg-defs';

const resultTypes = [
    {
        typesAssigned: ['locality'],
        label: 'typecity',
        icon: CITY__16
    },
    {
        typesAssigned: ['train_station'],
        label: 'typetrainstation',
        icon: TRAIN__16
    },
    {
        typesAssigned: ['metro_station'],
        label: 'typemetrostation',
        icon: TRAIN__16
    },
    {
        typesAssigned: [
            'continent',
            'country',
            'administrative_division_level_1',
            'administrative_division_level_2',
            'administrative_division_level_3',
            'administrative_division_level_4',
            'administrative_division_level_5',
            'touristic_region',
            'natural_feature',
            'postal_code',
            'natural_feature',
            'beach',
            'island',
            'ski_area'
        ],
        label: 'typeregion',
        icon: MAP__16
    },
    {
        typesAssigned: [
            'neighborhood',
            'sublocality_level_1',
            'sublocality_level_2',
            'sublocality_level_3',
            'sublocality_level_4',
            'sublocality_level_5',
            'neighborhood'
        ],
        label: 'typeneighborhood',
        icon: MAP__16
    },
    {
        typesAssigned: [
            'point_of_interest',
            'poi',
            'premise',
            'premises',
            'event',
            'establishment',
            'museum',
            'park',
            'restaurant',
            'transportation'
        ],
        label: 'typelandmark',
        icon: LOCATION__16
    },
    {
        typesAssigned: ['airport'],
        label: 'typeairport',
        icon: PLANE__16
    }
];

export function getSuggestionDetails(type) {
    let details = [];
    if (type) {
        type = type.toLowerCase();

        details = resultTypes.filter((resultData) => {
            return resultData.typesAssigned.indexOf(type) >= 0;
        });
    }

    return {
        label: details[0] ? details[0].label : 'typeregion',
        icon: details[0] ? details[0].icon : LOCATION__16
    };
}
